import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconAppChannelVarietyProps } from './IconAppChannelVariety.types'
import * as Styled from './styles/IconAppChannelVariety.style'

import { nonThemeableRules } from '../../ruleSet'

const IconAppChannelVariety: FC<IconAppChannelVarietyProps> = ({
  size = nonThemeableRules.defaultSize as number as IconAppChannelVarietyProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconAppChannelVarietyProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M7.5 9.215v3.555a.31.31 0 0 0 .293.312.29.29 0 0 0 .191-.062l.043-.032 2.274-1.691.066-.047a.297.297 0 0 0 0-.5l-.066-.05-2.266-1.68a.316.316 0 0 0-.344-.079.31.31 0 0 0-.191.297v.028m10.992 2.109V5.539h-1.8M2.535 15.031v-8c0-.84.309-1.375 1.07-1.449l.508-.031-.16.008'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M16.535 11.145V4.77l-12.93.812m-1.07 9.449c0 .75.606 1.266 1.465 1.422l11.086 1.059c.066 0 .125.008.187.011m3.293-10.98h1.914v4.836m-2.859 8.769h1.746m-3.785-5.957v-1.625c0-.578.469-1.05 1.05-1.05H21.5v8.957c0 .578-.469 1.047-1.047 1.047h-3.82c-.582 0-1.051-.47-1.051-1.047V14.19'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconAppChannelVariety
